import { Core } from "@faire/design-tokens";
import { ISelectOptionProps } from "@faire/help-center-utils/components/SearchableSelect/SearchableSelect";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import React from "react";

import { DropdownOptionWrapper, OptionName } from "./styles";

export const DropdownOption: React.FC<
  ISelectOptionProps & {
    selected?: boolean;
  }
> = (props) => {
  const handleClick = () => {
    props.onSelect?.(props.option);
  };
  return (
    <DropdownOptionWrapper
      selected={props.selected}
      key={props.option.customerBrandOrderToken}
      onClick={handleClick}
    >
      {props.option.date ? (
        <Column flex={1}>
          <Typography>{props.option.date}</Typography>
        </Column>
      ) : null}
      <OptionName>{props.option.name}</OptionName>
      <Spacer size={12} />
      {props.option.customerBrandOrderToken ? (
        <Column flex={1}>
          <Typography color={Core.text.subdued} align="right">
            {props.option.customerBrandOrderToken}
          </Typography>
        </Column>
      ) : null}
    </DropdownOptionWrapper>
  );
};
